import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { storeDataProps, storeResponseProps, updateStoreDetailsProps } from "../../components/settings/storeSetting/storeSettingModule";

interface initialState {
    loading: boolean,
    storeDetails: storeDataProps | null,
    error: string | null,

}
const initialState: initialState = {
    loading: false,
    storeDetails: null,
    error: null,
}

export const posStoreDetails = createAsyncThunk("storeSettings/fetchPosStoreDetails", ({ storeId }: { storeId: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.fetchPosStoreDetails, { storeId: storeId })
    return HttpRoutingService?.getMethod<storeResponseProps>(url)
})
export const updateStore = createAsyncThunk("storeSettings/updateStoreDetails", ({ storeId, data }: { storeId: number, data: updateStoreDetailsProps }) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateStoreDetails, { storeId: storeId })
    return HttpRoutingService?.putMethod<object>(url, { "formValue": data })
})

export const storeSettingSlice = createSlice({
    name: "storeSetting",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(posStoreDetails?.pending, (state) => {
                state.loading = true
            })
            .addCase(posStoreDetails?.fulfilled, (state, action) => {
                state.loading = false
                state.storeDetails = action.payload?.settings
                state.error = null
            })
            .addCase(posStoreDetails?.rejected, (state, action) => {
                state.loading = false
                state.error = action?.error?.message as string
            })
    }
})

export default storeSettingSlice?.reducer